module.exports = __webpack_public_path__ + "static/media/SK.27789656.png";